<script setup>
import NotificationsToaster from '@/components/notifications/NotificationsToaster.vue';
</script>

<template>
    <router-view />
    <NotificationsToaster />
</template>

<style scoped></style>

